import { useState, useEffect, createElement, forwardRef, useCallback } from 'react'
import { Map } from 'mapbox-gl'
import bbox from '@turf/bbox'
import { BuildingType } from '../interface-type'
import DarkTheme from '../map-styles/dark'
import LightTheme from '../map-styles/default'
import DarkVekinTheme from '../map-styles/dark-vekin'

const Building = forwardRef((props: BuildingType, ref: any) => {
    const [map, setmap] = useState<Map | any | null>(null)
    const [prevBuilding, setprevBuilding] = useState<any>(null)

    const onClickFeature = (e: any) => {
        props.onClickBuilding(e.features[0], props.buildings)
    }

    const onMouseenter = () => {
        map.getCanvas().style.cursor = 'pointer';
    }

    const onMouseleave = () => {
        map.getCanvas().style.cursor = '';
    }

    const updateBuilding = useCallback(
        () => {
            if (!prevBuilding && props.buildings) {
                const _bbox = bbox(props.buildings)
                map.fitBounds(_bbox, { padding: 100 });
                map.addSource('building-source', {
                    'type': 'geojson',
                    'data': props.buildings
                })
                map.addLayer({
                    'id': 'ground-building',
                    'type': 'fill',
                    'source': 'building-source',
                    'paint': {
                        'fill-color': [
                            'case',
                            ['==', ['get', 'selected'], true],
                            props.selectedColor,
                            props.defaultColor // default
                        ],
                        'fill-opacity': 0.9
                    }
                });
                map.addLayer({
                    'id': 'building-3d',
                    'type': 'fill-extrusion',
                    'source': 'building-source',
                    'paint': {
                        'fill-extrusion-color': [
                            'case',
                            ['==', ['get', 'selected'], true],
                            props.selectedColor,
                            props.defaultColor // default
                        ],
                        'fill-extrusion-height': ['get', 'height'],
                        'fill-extrusion-base': ['get', 'base'],
                        'fill-extrusion-opacity': 1
                    }
                });
                map.on('click', 'building-3d', onClickFeature)
                map.on('mouseenter', 'building-3d', onMouseenter);
                map.on('mouseleave', 'building-3d', onMouseleave);
            } else if (prevBuilding && props.buildings) {
                map.off('click', 'building-3d', onClickFeature)
                map.off('mouseenter', 'building-3d', onMouseenter);
                map.off('mouseleave', 'building-3d', onMouseleave);
                map.getSource('building-source').setData(props.buildings)
                map.on('click', 'building-3d', onClickFeature)
                map.on('mouseenter', 'building-3d', onMouseenter);
                map.on('mouseleave', 'building-3d', onMouseleave);

            } else {
                if (map && prevBuilding) {
                    const mapLayer = map.getStyle().layers.filter((l: any) => l.source === 'building-source')
                    mapLayer.map((l: any, i: number) => {
                        map.removeLayer(l.id)
                        if (mapLayer.length === i + 1) {
                            map.removeSource('building-source')
                        }
                    })
                }
            }
            setprevBuilding(props.buildings)
        },
        [map, prevBuilding],
    )

    useEffect(() => {
        if (map) {
            updateBuilding()
        }
        return () => {
            if (map) {
                map.off('click', 'building-3d', onClickFeature)
                map.off('mouseenter', 'building-3d', onMouseenter);
                map.off('mouseleave', 'building-3d', onMouseleave);
            }
        };
    }, [map, props.buildings])

    useEffect(() => {
        if (map) {
            const sourceBuilding = map.getStyle().sources['building-source']
            const layerBuildings = map.getStyle().layers.filter((l: any) => l.source === 'building-source')
            map.setStyle(props.theme === 'dark' ? DarkTheme : props.theme === 'dark-vekin' ? DarkVekinTheme : LightTheme)
            if (sourceBuilding && layerBuildings.length > 0) {
                map.addSource('building-source', sourceBuilding)
                layerBuildings.map((l: any) => {
                    map.addLayer(l)
                })
            }

        }
        return () => {

        };
    }, [props.theme])

    useEffect(() => {
        if (!map) {
            const mapRender = new Map({
                container: ref.current,
                style: props.theme === 'dark' ? DarkTheme : props.theme === 'dark-vekin' ? DarkVekinTheme : LightTheme,
                center: props.center,
                zoom: props.zoom,
                pitch: props.pitch,
                bearing: props.bearing
            })
            mapRender.on('load', () => {
                setmap(mapRender)
            })

        }
        return () => {
            if (map) {
                map.remove()
            }
        };
    }, [map])
    return (
        createElement("div", {
            style: { height: "100%", width: "100%" },
            ref: ref
        })
    )
})

Building.defaultProps = {
    buildings: null,
    theme: 'light',
    defaultColor: '#808080',
    selectedColor: '#228B22',
    center: [0, 0],
    zoom: 10,
    pitch: 60,
    bearing: 20,
    onClickBuilding: () => { }
}

export default Building
